import api from '../../../services/api.service';
export const types = {
    SET_VALUE: 'deliveriesCarriersSetValue',
    SET_CNPJ: 'deliveriesCarriersSetCNPJ',
    SET_NAME: 'deliveriesCarriersSetName',
    SET_PERIOD: 'deliveriesCarriersSetPeriod',
    SET_SHOW_CARRIER: 'deliveriesCarriersetSethowCarrier',
    SET_SHOW_PERIOD: 'deliveriesCarriersetSethowPeriod',
    LOADER_SHOW: 'loaderShow',
    LOADER_HIDDEN: 'loaderHide'
}

export function setValue(value) {
    return {
        type: types.SET_VALUE,
        value
    }
}


export function setCNPJ(carrier) {
    return {
        type: types.SET_CNPJ,
        carrier,
    }
}

export function setName(name) {
    return {
        type: types.SET_NAME,
        name,
    }
}

export function setPeriod(period) {
    return {
        type: types.SET_PERIOD,
        period,
    }
}

export function setShowCarrier(showCarrier) {
    return {
        type: types.SET_SHOW_CARRIER,
        showCarrier,
    }
}

export function setShowPeriod(showPeriod) {
    return {
        type: types.SET_SHOW_PERIOD,
        showPeriod,
    }
}

export function loaderShow() {
    return {
        type: types.LOADER_SHOW,
        async: true,
    }
}

export function loaderHide() {
    return {
        type: types.LOADER_HIDDEN,
        async: false,
    }
}

export function load() {
    return (dispatch, getState) => {
        const state = getState().crudDeliveriesCarrier.deliveriesCarriers;
        const filter = {
            carrierDocument: state.filters.carrier.documentNumber || "",
            period: state.filters.period.period || "CURRENT_MONTH"
        }
        console.log("filter=", filter)
        const URL = `/api/v1/lognex/reports/indicators/deliveries-carriers`;

        dispatch(loaderShow())
        api.post(URL, filter)
            .then(({ data }) => { 
                
                const {
                    countCargasPlanejadas = 0,
                    countCargasRealizadas = 0,
                    countCargasAtrasadas = 0,
                    countCargasTransito = 0,
                } = data.data;

                dispatch(setValue({ countCargasPlanejadas, countCargasRealizadas, countCargasAtrasadas, countCargasTransito }))
                dispatch(loaderHide())
            })
            .catch((error) => {
                const { countCargasPlanejadas = 0, countCargasRealizadas = 0, countCargasAtrasadas = 0, countCargasTransito = 0} = {};
                dispatch(setValue({ countCargasPlanejadas, countCargasRealizadas, countCargasAtrasadas, countCargasTransito }))
                console.log(error)
                dispatch(loaderHide())
            })
    }
}

